
import { computed, defineComponent, inject } from "vue";
import { StoreKey } from "@/symbols";

export default defineComponent({
  name: "SubtitleViewer",
  setup() {
    const store = inject(StoreKey);
    if (!store) {
      throw new Error(`Could not resolve ${StoreKey.description}`);
    }

    const text = computed(() => store.state.currentCue.text.split("\n"));

    return {
      text
    };
  }
});
